export default __webpack_public_path__ + "static/media/alicemoitie.ac867162.jpeg";